import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import "bootstrap";
import "@fortawesome/fontawesome-free";
import "@fortawesome/fontawesome-free/css/all.css";
import "./css/bootstrap.min.css";
import "./css/main.css";
import "jquery-touchswipe";
// import "bootstrap/dist/css/bootstrap.min.css"; USE catalogapp bootstrap css instead

Vue.config.productionTip = false;

new Vue({
  router,
  render: h => h(App)
}).$mount("#app");
